import $ from 'jquery'
import 'jquery-migrate/dist/jquery-migrate'
import './modules/_skip-link-focus-fix'
import './modules/_foundation-scripts'
import './modules/_navigation'

import 'slick-carousel/slick/slick.min'

import 'jquery-match-height/jquery.matchHeight.js'

/**
 * Notes:
 *
 * Although jQuery is imported above, it is not bundled
 * with the transpiled assets. jQuery needs to be global
 * on the website.
 *
 * All imports belong at the top of the file.
 *
 * Webpack only outputs this one script file, if you need
 * another file then add it to the scripts-list.js file as
 * another line in the scripts_list object.
 *
 * The scripts_list const is imported into the webpack
 * config. I've done this so that you do not have to
 * wade through the config to find what is being
 * compiled out as its own file.
 *
 * When importing node modules that are not ES6 modules,
 * you do not need to path them as '../../node_modules/'.
 * Gulp knows about the node_modules directory, so all you need
 * to do is path them as if you were already in the node_modules
 * directory
 *
 * Instead of:
 * import '../../node_modules/jquery-migrate/dist/jquery-migrate';
 *
 * Use:
 * import 'jquery-migrate/dist/jquery-migrate';
 *
 */

/*************** Search ***************/

$('.search-icon').on('click', function (event) {
	event.preventDefault()
	$('.search-container').slideToggle()
	$('html, body').animate({ scrollTop: 0 }, 800)
})

$('.close-button').on('click', function (event) {
	event.preventDefault()
	$('.search-container').slideToggle()
	$('html, body').animate({ scrollTop: 0 }, 800)
})

/*************** Template part region toggle button ***************/
$('#theme_debug_regions').on('click', function (event) {
	event.preventDefault()

	$('.placeHolderPosition').slideToggle()
})

/*************** Search toggle button ***************/
$('#js_search_toggle, #js_search_toggle_quicklinks').on('click', function (event) {
	event.preventDefault()

	$('#js_search_container').slideToggle()
})

/*************** Global Gallery ***************/
$('.gallery-columns-1').each((index, gallery) => {
	import('slick-carousel').then(() => {
		$(gallery).slick({
			prevArrow: '<button class="slick-prev slick-arrow"><span class="show-for-sr">Previous</span></button>',
			nextArrow: '<button class="slick-next slick-arrow"><span class="show-for-sr">Next</span></button>',
			infinite: true,
			autoplay: false,
			autoplaySpeed: 10000,
			adaptiveHeight: true,
		})
	})
})

$('.match-height').matchHeight()

/*************** Footer Partner Logos ***************/
$(document).ready(function () {
	$('.partner-logos').slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 4000,
		responsive: [
			{
				breakpoint: 1350,
				settings: {
					arrows: false,
				},
			},
			{
				breakpoint: 1060,
				settings: {
					arrows: false,
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 800,
				settings: {
					arrows: false,
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 640,
				settings: {
					arrows: false,
					slidesToShow: 1,
				},
			},
		],
	})
})
